import { downloadInit } from 'redux/reducers/init';
import {
  addDownloadingGroup,
  removeDownloadingGroup,
  updateDownloadingGroup,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const download = createReducer(downloadInit, {
  [addDownloadingGroup.type]: (state, action) => {
    const { id } = action.payload;
    state.downloadingGroup[id] = {
      isDownloading: true,
      percent: 0,
    };
  },

  [removeDownloadingGroup.type]: (state, action) => {
    const { id } = action.payload;
    delete state.downloadingGroup[id];
  },

  [updateDownloadingGroup.type]: (state, action) => {
    const { percent, id } = action.payload;
    state.downloadingGroup[id].percent = percent;
  },
});

export default download;
